import React, { useState } from 'react'
import { Link } from 'gatsby'

const SectionBackground = ({ BGObject, heading, description, fluidHeight = false }) => {
  const [showBG, setShowBG] = useState(0)
  const containerClasses  = fluidHeight ? "relative lg:h-full md:h-[570px] h-[60vw]" : "relative lg:h-full md:h-[570px] h-[200px]"
  return (
    <div className='xl:h-[1080px] lg:h-[768px] flex flex-col relative container px-0'>
      <div className={containerClasses}>
        {BGObject.map((background, index) => {
          return (
            <div
              key={index}
              className={`${
                showBG !== index ? 'opacity-0' : 'opacity-100'
              } absolute top-0 left-0 bottom-0 right-0 transition-all duration-500 ease-in-out`}
            >
              <img
                src={background.img}
                alt={background.alt}
                loading='lazy'
                className='h-full w-full object-cover'
              />
            </div>
          )
        })}
      </div>
      <div
        className='lg:py-[16.5px] lg:top-[24px] lg:right-[24px] lg:px-[32px] lg:w-auto lg:absolute bg-white container pb-[40px] flex flex-col  '
        data-aos='fade-up'
        data-aos-duration='500'
        data-aos-easing='ease-in-out'
        data-aos-offset='0'
      >
        <p className='md:order-0  text-xl  order-1 '>{heading}</p>
        <p className='lg:max-w-[325px] md:order-1 md:max-w-[565px] md:text-sm mt-[16px] order-2 '>
          {description}
        </p>
        <Link
          to='/contact'
          className='lg:mt-[16px] lg:mb-[24px] md:order-2 md:mb-[24px] secondary-button mt-[24px] mb-[10px]  w-fit order-3 '
        >
          Contact us
        </Link>
        <div className='lg:max-w-full lg:gap-[32px] md:max-w-[340px] flex justify-between border-b-[1px] border-gray-200 order-0 mt-[25px] mb-[20px]  lg:order-3 lg:mt-0 lg:mb-0'>
          {BGObject.map((background, index) => {
            return (
              <div
                role='presentation'
                key={index}
                className={`${
                  showBG === index
                    ? 'text-black-100 bg-active'
                    : 'text-gray-200'
                } lg:pb-[16.5px] pb-[25px] relative cursor-pointer`}
                onClick={() => {
                  setShowBG(index)
                }}
              >
                {background.name}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default SectionBackground
